var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "ob1-skeleton my-2" }, [
        _c("div", {
          staticClass: "ob1-skeleton-white",
          staticStyle: { width: "150px", height: "20px" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-shrink-0 pe-1" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "30px", height: "30px" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow-1 align-self-center" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "150px", height: "10px" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-shrink-0 pe-1" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "30px", height: "30px" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow-1 align-self-center" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "150px", height: "10px" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-shrink-0 pe-1" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "30px", height: "30px" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow-1 align-self-center" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "150px", height: "10px" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-shrink-0 pe-1" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "30px", height: "30px" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow-1 align-self-center" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "150px", height: "10px" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex mb-2" }, [
        _c("div", { staticClass: "flex-shrink-0 pe-1" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "30px", height: "30px" },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow-1 align-self-center" }, [
          _c("div", { staticClass: "ob1-skeleton" }, [
            _c("div", {
              staticClass: "ob1-skeleton-white",
              staticStyle: { width: "150px", height: "10px" },
            }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }